import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RouterProvider } from 'react-router-dom';
import { router } from './components/shared/routing/routes';
import { AuthProvider } from './features/auth/context/AuthProvider';
import { ThemeProvider } from './context/ThemeProvider';
import { LanguageProvider } from './context/LanguageProvider';
import { AppErrorBoundary } from './components/errors';
import { initSentry } from './lib/logging/sentry';
import { ReferenceAliasProvider } from './context/ReferenceAliasProvider';

// Initialize Sentry error tracking (production only)
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <LanguageProvider>
        <AuthProvider>
          <ThemeProvider>
            <ReferenceAliasProvider>
              <RouterProvider router={router} />
            </ReferenceAliasProvider>
          </ThemeProvider>
        </AuthProvider>
      </LanguageProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);
